import React, { useState, useEffect } from "react";
import "./ConfirmPassportDetails.css"; // Create a CSS file for styling

import "../OnboardingCustomerInformation/OnboardingCustomerInformation.modules.css"; // Import CSS for styling
import { useTranslation } from "react-i18next";
import * as AppUrls from "../../../constants/AppUrls";
import { Redirect } from "react-router-dom";
import NavbarOnboarding from "../NavbarOnboarding/NavbarOnboarding";
import KYCimg from "../../../assets/images/Sharjah/KYC.png";
import i18next from "i18next";
import { useLocation } from "react-router-dom";
import { confirmAlert } from "react-confirm-alert";
import "react-confirm-alert/src/react-confirm-alert.css";
import * as Helpers from "../../../global/Helpers";
import * as utils from "../../../global/utils";
import * as Constants from "../../../constants/Constants";
import SessionExpiredPOPup from "../SessionExpiredPOPup/SessionExpiredPOPup";

const ConfirmPassportDetails = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const propsDate = location.state || null;

  ;
  const [Nationality, setNationality] = useState([]);
  const [NonSIB, setNonSIB] = useState(false);
  const [formData, setFormData] = useState({
    fullName: propsDate?.passportData?.name || "",
    PassportNumber: propsDate?.passportData?.PassportNumber || "",
    birthDate: propsDate?.passportData?.birthDate || "",
    expiryDate: propsDate?.passportData?.expiryDate || "",
    nationality: propsDate?.passportData?.nationality || "",
    gender:
      propsDate?.passportData?.Gender === "F"
        ? "Female"
        : propsDate.passportData.Gender === "M"
        ? "Male"
        : "",
  });

  const [redirect, setRedirect] = useState(null);

  // useEffect(() => {
  //   fetchNationality();
  // }, [i18next.language]);

  const handleSubmit = (e) => {
    // e.preventDefault();
    var Items = [
      { ID: "9", Value: formData.PassportNumber },
      { ID: "50", Value: formData.expiryDate },
      { ID: "3", Value: formData.fullName },
     { ID: "403", Value: formData.birthDate },
      { ID: "404", Value: formData.nationality },
      { ID: "405", Value: propsDate?.passportData?.Gender },

      { ID: "258", Value: "1" },
    ];
    saveKycData(Items);
    CallAMLSib();
    // setRedirect(AppUrls.OnboardingNonSIBAccountSignature);
  };

  const CallAMLSib = async () => {
    try {
      const params = {
        ReqID: localStorage.getItem("RID"),
      };
      var response = utils.CallAMLSib(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            // Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("CallAMLSib", error);
        });
    } catch (error) {
      console.log("CallAMLSib", error);
    }
  };

  const validateSubmit = () => {
    ;

    if (formData.PassportNumber === "") {
      Helpers.errorNotify(t("PassportNumber"), i18next.language);
      return false;
    }
    if (formData.fullName === "") {
      Helpers.errorNotify(t("fullName"), i18next.language);
      return false;
    }

    if (formData.birthDate === "") {
      Helpers.errorNotify(t("birthDate"), i18next.language);
      return false;
    }
    if (formData.nationality === "") {
      Helpers.errorNotify(t("nationality"), i18next.language);
      return false;
    }
    if (formData.gender === "") {
      Helpers.errorNotify(t("gender"), i18next.language);
      return false;
    }
    return true;
  };

  const saveKycData = async (Items) => {
    if (!validateSubmit()) return;

    try {
      const body = {
        RequestItems: Items,
        reqID: localStorage.getItem("RID"),
      };

      var response = utils.CallKYCAPI(Constants.GetKYCCibc, body);
      await response
        .then((response) => {
          ;
          if (response.data.Error_code === "0") {
            setRedirect(AppUrls.OnboardingNonSIBAccountSignature);
          } else {
            Helpers.errorNotify(response.data.Error_Msg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("saveKycData", error);
        });
    } catch (error) {
      console.error("Error posting data saveKycData:", error);
    }
  };
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const handleBack = (e) => {
    e.preventDefault();
    setRedirect(AppUrls.onboardingPersonal);
  };

  const onclickExistingSIB = (e) => {
    setNonSIB(false);
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          // <div className="popup">
          //   <div className="popup-div">
          //     <h5>Would you like to proceed with opening an investment account and provide your consent ?</h5>
          //     <div>
          //       <button>{t("Yes")}</button>
          //       <button >{t("No")}</button>
          //     </div>
          //   </div>
          // </div>
          <div class="popup-overlay">
            <div class="popup-container-KYC">
              <h6>{t("investmentAccountMsg")}</h6>
              <button
                class="yes-button"
                onClick={(e) => {
                  setRedirect(AppUrls.OnboardingNonSIBAccount);
                  onClose();
                }}
              >
                {t("Yes")}
              </button>
              <button
                class="no-button"
                onClick={(e) => {
                  setRedirect(AppUrls.onboardingUserConfirms);
                  onClose();
                }}
              >
                {t("No")}
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const onclickNonSIB = (e) => {
    setNonSIB(true);
    confirmAlert({
      customUI: ({ onClose }) => {
        return (
          <div class="popup-overlay">
            <div class="popup-container-KYC">
              <h6>{t("wishOpenAccountSIB")}</h6>
              <button
                class="yes-button"
                onClick={(e) => {
                  onclickExistingSIB(e);
                  // onClose();
                }}
              >
                {t("Yes")}
              </button>
              <button
                class="no-button"
                onClick={(e) => {
                  setNonSIB(true);

                  setRedirect(AppUrls.onboardingUserConfirms);
                  onClose();
                }}
              >
                {t("No")}
              </button>
            </div>
          </div>
        );
      },
    });
  };
  const fetchNationality = async () => {
    try {
      const params = {
        _FormType: "1",
        Lang: i18next.language === "ar" ? "AR" : "EN",
      };
      var response = utils.GetNationalityLookupAPI(params);
      await response
        .then((response) => {
          ;
          if (response.data.ErrorMsg === "success") {
            setNationality(response.data.resData);
          } else if (response.data.ErrorMsg === "Invalid token") {
            confirmAlert({
              customUI: ({ onClose }) => {
                return (
                  <SessionExpiredPOPup
                    setRedirect={setRedirect}
                    onClose={onClose}
                  />
                );
              },
            });
          } else {
            Helpers.errorNotify(response.data.ErrorMsg, i18next.language);
          }
        })
        .catch((error) => {
          console.log("fetchNationalityApi", error);
        });
    } catch (error) {
      console.log("fetchNationality", error);
    }
  };

  if (redirect !== null) {
    return (
      <Redirect
        to={{
          pathname: redirect,
          state: { NonSIB: NonSIB },
        }}
      />
    );
    // return <Redirect to={redirect} />;
  }

  return (
    <>
      <NavbarOnboarding />

      <div className="login-main-container">
        <div className="KYCDivImg">
          <h2 className="OpenYourAccountwithUs">{t("OpenYourAccountwithUs")}</h2>
          <img className="KYCImg" src={KYCimg} />
        </div>
        <div className="CustomerInfo-container">
          <div className="CustomerInfo-form ConfirmPassportDetails">
            <h2 style={{ marginBottom: "2rem" }}>
              {" "}
              {t("ConfirmPassportDetails")}
            </h2>
            <div className="form-group">
              <label>{t("PassportNumber")}</label>
              <input
                type="text"
                name="PassportNumber"
                value={formData.PassportNumber}
                onChange={handleChange}
                disabled
              />
              {/* {errors.PassportNumber && <span className="error">{errors.PassportNumber}</span>} */}
            </div>

            {/* English Names */}
            <div className="form-group">
              <label>{t("full_name")}</label>
              <input
                type="text"
                name="fullName"
                value={formData.fullName}
                onChange={handleChange}
                disabled
              />
              {/* {errors.fullName && <span className="error">{errors.fullName}</span>} */}
            </div>

            {/* Birth Date */}
            <div className="form-group">
              <label>{t("field_date_of_birth")}</label>
              <input
                type="text"
                name="birthDate"
                value={formData.birthDate}
                onChange={handleChange}
                disabled
              />

              {/* <input type="date" name="birthDate" value={formData.birthDate} onChange={handleChange} dateFormat="dd/MM/yyyy" disabled /> */}
              {/* {errors.birthDate && <span className="error">{errors.birthDate}</span>} */}
            </div>
            {/* expiry Date */}
            <div className="form-group">
              <label>{t("ExpiryDate")}</label>
              <input
                type="text"
                name="expiryDate"
                value={formData.expiryDate}
                onChange={handleChange}
                disabled
              />

              {/* <input type="date" name="expiryDate" value={formData.expiryDate} onChange={handleChange} dateFormat="dd/MM/yyyy" disabled /> */}
              {/* {errors.birthDate && <span className="error">{errors.birthDate}</span>} */}
            </div>

            {/* Nationality */}
            {/* <div className="form-group">
              <label>{t("field_nationality")}</label>

              <select id="nationality" name="nationality" value={formData.nationality} onChange={handleChange} disabled>
                {Nationality.map((country, index) => (
                  <option key={index} value={country.value}>
                    {country.NationalityName}
                  </option>
                ))}
              </select>

            </div> */}

            {/* nationality*/}
            <div className="form-group">
              <label>{t("field_nationality")}</label>
              <input
                type="text"
                name="nationality"
                value={formData.nationality}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            {/* Gender */}
            {/* <div className="form-group">
              <label>{t("field_gender")}</label>
              <select name="gender" value={formData.gender} onChange={handleChange} disabled>
                <option value="" disabled>
                  {t("Select_Gender")}
                </option>
                <option value="M">Male</option>
                <option value="F">Female </option>
              </select>
            </div> */}

            {/* Gender*/}
            <div className="form-group">
              <label>{t("field_gender")}</label>
              <input
                type="text"
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                disabled
              />
              {/* {errors.firstNameEnglish && <span className="error">{errors.firstNameEnglish}</span>} */}
            </div>

            <button
              type="submit"
              className="submit-button"
              onClick={handleSubmit}
            >
              {t("Confirm")}
            </button>
            {/* <div>
             
              <button className="backBtn" onClick={handleBack}>
                {t("back")}
              </button>
            </div> */}
          </div>
        </div>
      </div>
    </>
  );
};

export default ConfirmPassportDetails;
